/**
 * Animate header
 */
const tlHeader = gsap.timeline({
  scrollTrigger: {
    trigger: ".page-header",
    start: "top top",
    end: "bottom top",
    scrub: 2
  }
});

gsap.utils.toArray(".parallax").forEach(layer => {
  const depth = layer.dataset.depth;
  const movement = -(300 * depth)
  tlHeader.to(layer, {y: movement, ease: "none"}, 0)
});

/**
 * Animate houses
 */
// const tlMain = gsap.timeline({
//   scrollTrigger: {
//     // markers: true,
//     trigger: ".page-main",
//     start: "-=50% top",
//     end: "+=400%",
//     scrub: true,
//     scrub: 2
//   }
// });
// tlMain.from('.family .house-modell-content', { duration: 0.2, opacity: 0, yPercent: 100})
//       .from('.loft .house-modell-image img', { yPercent: 100})
//       .to('.family .house-modell-content', { duration: 0.1, opacity: 0, yPercent: -100}, "<")
//       .from('.loft .house-modell-content', { duration: 0.1, opacity: 0, yPercent: 100}, "<0.2");

// ScrollTrigger.create({
//   // markers: true,
//   trigger: ".page-main",
//   start: "top top",
//   end: "+=350%",
//   scrub: true,
//   pin: ".page-main"
// });


/*** Different ScrollTrigger setups for various screen sizes (media queries) ***/
ScrollTrigger.matchMedia({

  // desktop
  "(min-width: 800px)": function() {
    // setup animations and ScrollTriggers for screens over 800px wide (desktop) here...
    // ScrollTriggers will be reverted/killed when the media query doesn't match anymore.

    gsap.utils.toArray(".house-modell-content").forEach(houseModellContent => {
      gsap.from(houseModellContent, {
        duration: 1,
        stagger: 0.2,
        yPercent: 50,
        opacity: 0,
        scrollTrigger: {
          // markers: true,
          trigger: houseModellContent,
          start: "center bottom"
        }
      });
    });

  },

});



